import { Component, Element, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'cradlepoint-video',
  styleUrl: 'cradlepoint-video.css',
  shadow: true,
})
export class CradlepointVideo {
  @Element() host: HTMLElement;
  @Prop() videoUrl            : string;
  @Prop() bgImage             : string;
  @Prop() width               : string = '100%';
  @Prop() aspectRatio         : string = '16:9';
  @Prop() popupWidth          : string  = '100%';
  @Prop() maxWidth            : string  = '1280px';

  toggleVideoPopup = () => {
    let host = this.host;
    let videoUrl = host.getAttribute('video-url');
    let body = host.closest('body');
    if( host.getAttribute('data-active') == 'false' ){

      let backDrop = document.createElement('div');
      backDrop.setAttribute("id", "modal-backDrop");
      body.appendChild(backDrop);

      let popupWrapper = document.createElement('div');
      popupWrapper.setAttribute("class", "popup video-popup-wrapper");
      popupWrapper.setAttribute("style", `
      width: ${host.style.width};
      top: ${host.offsetTop}px;
      max-width:${host.style.maxWidth};
    `);
      popupWrapper.innerHTML = `<span class='close'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="24px" height="24px"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg></span>
      <iframe src="${videoUrl}" style="aspect-ratio:${host.style.aspectRatio};" class="videoIframe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullScreen=""></iframe>`;
      body.appendChild(popupWrapper);
      host.dataset.active = 'true';

      let close = body.querySelector('.video-popup-wrapper .close');
      close.addEventListener('click', function(){
        body.querySelector('.video-popup-wrapper').remove();
        host.dataset.active = 'false';
        body.querySelector('#modal-backDrop').remove();
      });

      body.querySelector('#modal-backDrop').addEventListener('click', function(){
        body.querySelector('.video-popup-wrapper').remove();
        host.dataset.active = 'false';
        body.querySelector('#modal-backDrop').remove();
      });
    }else{
      body.querySelector('.video-popup-wrapper').remove();
      host.dataset.active = 'false';
      body.querySelector('#modal-backDrop').remove();
    }
  }

  render() {

    let featuredImage = '';

    if (this.videoUrl) {
      var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = this.videoUrl.match(regExp);
      if (match && match[2].length == 11) {
          var id = match[2];
          featuredImage = 'https://img.youtube.com/vi/' + id + '/maxresdefault.jpg';
      }
    }

    return (
      <Host
        style={{
          width: this.width,
          maxWidth: this.maxWidth,
          backgroundImage: this.bgImage ? `url(${this.bgImage})` : `url(${featuredImage})`,
          aspectRatio: this.aspectRatio.replace(':','/'),
        }}
        onClick={this.toggleVideoPopup}
        data-active="false"
      >
      </Host>
    );
  }

}
